
import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";
import { PrivateInterceptorsPR } from "../../../interceptors/PrivateinterceptorsPR";

// OBTENER MENU
export const getResumenConsumoProductosBodega = async (anual, IPS) => {
    if(IPS){
        const result = await PrivateInterceptor(`Compras/Purchases/ResumenConsumoProductos/${anual}`, 'GET');
        return result;
    }else{
        const result = await PrivateInterceptor(`Inventario/InventarioMateriales/ResumenConsumoProductos/${anual}`, 'GET');
        return result;
    }
}

export const getResumenInventarioRevisado = async () => {
   const result = await PrivateInterceptor('Base/Inventarios/InventarioMateriales/revisado', 'GET');
   return result;
}

export const getHistoricoInventario = async (Mes, Anio) => {
   const result = await PrivateInterceptor('Base/Inventarios/InventarioMateriales/mesCierre', 'POST', {Mes, Anio});
   return result;
}

//Quimicos y Colorantes
export const getInventarioMensualQC = async() =>{
    const result = await PrivateInterceptor(`Base/Inventarios/InventarioMateriales/MensualQC`,'GET');
    return result;
}

export const getHistoricoInventarioQC = async (Mes, Anio) => {
   const result = await PrivateInterceptor('Base/Inventarios/InventarioMateriales/mesCierreQC', 'POST', {Mes, Anio});
   return result;
}

//Bodega Hilaza
export const getInventarioMensualHilaza = async() =>{
    const result = await PrivateInterceptor(`Base/Inventarios/InventarioMateriales/MensualHilaza`,'GET');
    return result;
}

export const getHistoricoInventarioHilaza = async (Mes, Anio) => {
   const result = await PrivateInterceptor('Base/Inventarios/InventarioMateriales/mesCierreHilaza', 'POST', {Mes, Anio});
   return result;
}

//Combustibles
export const getInventarioMensualCombustible = async() =>{
    const result = await PrivateInterceptor(`Base/Inventarios/InventarioMateriales/MensualCombustible`,'GET');
    return result;
}

export const getHistoricoInventarioCombustible = async (Mes, Anio) => {
   const result = await PrivateInterceptor('Base/Inventarios/InventarioMateriales/mesCierreCombustible', 'POST', {Mes, Anio});
   return result;
}

//INFORMACION CUENTAS POR PAGAR
export const getInformacionEncabezadoCXP2 = async(informacion)=>{
    const result = await PrivateInterceptor(`Base/Inventarios/InventarioMateriales/InformacionEncInventarios`, 'POST', informacion);
    return result;
}

export const getInformacionEncabezadoCXPCombustible = async(informacion)=>{
    const result = await PrivateInterceptor(`Base/Inventarios/InventarioMateriales/InformacionEncInvCombustible`, 'POST', informacion);
    return result;
}

export const getIngresosPromedio = async(informacion) =>{
    const result = await PrivateInterceptor(`Base/Inventarios/InventarioMateriales/IngresosPromedio`, 'POST', informacion);
    return result;
}